// Horizontal location of the snackbar

export const TOP = "top";
export const BOTTOM = "bottom";